"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
exports.__esModule = true;
__export(require("./useCurrentEffect"));
__export(require("./useCurrentCallback"));
//# sourceMappingURL=index.js.map